import { Component, OnInit } from '@angular/core';
import { Http, Headers, Response,RequestOptions} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { AlertService,UserService } from '../_services/index';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { environment } from '../../environments/environment';
import { Angular2Csv } from 'angular2-csv/Angular2-csv';
import { config } from '../../config/acl';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-userfeedback',
  templateUrl: './userfeedback.component.html',
  styleUrls: ['./userfeedback.component.css']
})
export class UserfeedbackComponent implements OnInit {
    backendUrl:any;  
  	getdata:any;
    q_tags:any
  	dt:any;
  	loading = false;
    config_var : any;
    permission : any;
    lang_value: any;
  constructor(private activatedRoute: ActivatedRoute, private http: Http ,private userservice: UserService,private alertService: AlertService,private userService:UserService,private translate:TranslateService) {

   }

  ngOnInit() 
  {
    this.translate.get(['anf_comments','anf_Branch','anf_Name']).subscribe(res => {
           this.lang_value=res;
        }); 

    this.config_var = config;
    this.permission = parseInt(localStorage.getItem('permission'));
    let url=window.location.hostname;
    //  if(url=='app.foodbot.ai' || url=='dashboard.foodbot.ai'){this.backendUrl=environment.prod}
    //  else if(url=='stage.foodbot.ai'){ this.backendUrl=environment.stage}
    //  else if(url=='uat.foodbot.ai'){ this.backendUrl=environment.uat}  
    //  else{ this.backendUrl=environment.local}
    if (url == 'app.foodbot.ai' || url == 'dashboard.foodbot.ai') { this.backendUrl = environment.prod } else if (url == 'stage.foodbot.ai') { this.backendUrl = environment.stage } 
    else if (url == 'uat.foodbot.ai') { this.backendUrl = environment.uat } 
    else if (url == '127.0.0.1') { this.backendUrl = environment.local } 
    else { 
      this.backendUrl=window.location.origin
      this.backendUrl+="/apis"
    }

    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
      let restaurant_id=currentUser.restaurant_id;
     
     this.activatedRoute.params.subscribe((params: Params) => {
        this.dt = params['id'];
        console.log(this.dt);
      });

   let sql_new="SELECT * FROM fb_feedback_flow where restaurant_id="+restaurant_id
   this.userService.getdata(this.backendUrl,JSON.stringify({'query': sql_new}))
    .subscribe(data => {
        this.q_tags=data[0];
    })  


     let sql="SELECT  date_format(a.date_time,'%d-%b-%Y')dt,a.*,f.question1_type,f.question2_type,f.question3_type,f.question4_type FROM fb_feedback_report a  left join (select restaurant_id,question1_type,question2_type,question3_type,question4_type from  fb_feedback_flow where restaurant_id="+restaurant_id+" )f on a.restaurant_id=f.restaurant_id  where a.restaurant_id='"+restaurant_id+"' and date(a.date_time)='"+this.dt +"' order by date(a.date_time) desc";
     console.log(sql);
  	    let headers = new Headers ({  'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers, method: "post" });
        
      this.http.post(this.backendUrl+'/getdata',JSON.stringify({'query': sql}),options)
            .map(data => data.json())
            .subscribe(data => {
          this.getdata = data;
          console.log("I CANT SEE DATA HERE: ", this.getdata);
        });
      
      $(document).ready(function(){
          $('[data-toggle="tooltip"]').tooltip();   
     });

  }

   
  search(name) {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
      let restaurant_id=currentUser.restaurant_id;
     if(name)
     {
         this.loading=true;
     let sql="SELECT  date_format(a.date_time,'%d-%b-%Y')dt,a.*,f.question1_type,f.question2_type,f.question3_type,f.question4_type FROM fb_feedback_report a  left join (select restaurant_id,question1_type,question2_type,question3_type,question4_type from  fb_feedback_flow where restaurant_id="+restaurant_id+" )f on a.restaurant_id=f.restaurant_id where a.restaurant_id='"+restaurant_id+"' and date(a.date_time)='"+this.dt +"' and concat(a.first_name,' ',a.last_name) like '%"+name+"%' order by a.id desc";
  	 let headers = new Headers ({  'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers, method: "post" });
        
        return this.http.post(this.backendUrl+'/getdata',JSON.stringify({'query': sql}),options)
            .map(data => data.json())
            .subscribe(data => {
          this.getdata = data;
          this.loading=false;
          console.log("I CANT SEE DATA HERE: ", this.getdata);
        });
     }
  }
   refresh(){
       this.ngOnInit();
  } 
 


download() {
let currentUser = JSON.parse(localStorage.getItem('currentUser'));
let restaurant_id=currentUser.restaurant_id;
let sql="SELECT branch_name,concat(first_name,' ',last_name)as name,ifnull(question1_rating,' '),ifnull(question1_comment,' '),ifnull(question2_rating,' '),ifnull(question2_comment,' '),ifnull(question3_rating,' '),ifnull(question3_comment,' '),ifnull(question4_rating,' '),ifnull(question4_comment,' ') from fb_feedback_report where restaurant_id='"+restaurant_id+"' and date(date_time)='"+this.dt +"' order by date_time desc";
  //   console.log(sql);
        let headers = new Headers ({  'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers, method: "post" });
        
      this.http.post(this.backendUrl+'/getdata',JSON.stringify({'query': sql}),options)
            .map(data => data.json())
            .subscribe(data => {

var options = { 
fieldSeparator: ',',
quoteStrings: '"',
decimalseparator: '.',
showLabels: false, 
showTitle: false,
headers: [this.lang_value.anf_Branch,this.lang_value.anf_Name,this.q_tags.question1_tag,this.q_tags.question1_tag+' '+this.lang_value.anf_comments ,this.q_tags.question2_tag,this.q_tags.question2_tag+' '+this.lang_value.anf_comments,this.q_tags.question3_tag,this.q_tags.question3_tag+' '+this.lang_value.anf_comments,this.q_tags.question4_tag,this.q_tags.question4_tag+' '+this.lang_value.anf_comments] 
};

new Angular2Csv(data, 'Feedback Report',options);
 
})
}

}



// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/userfeedback/userfeedback.component.ts